import {
  PayPalCardFieldsProvider,
  PayPalCVVField,
  PayPalExpiryField,
  PayPalNameField,
  PayPalNumberField,
  usePayPalCardFields,
} from "@paypal/react-paypal-js";
import localeText from "../../locale";
import OrderService from "../../service/OrderService";
import { removelocalStorageToken } from "../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../utilities/sessionStorage/username";
import { useHistory, useLocation } from "react-router-dom";
import IntegrationService from "../../service/IntegrationService";
import AdvancedPayPalService from "../../service/AdvancedPayPalService";
import { useRef, useState, useCallback, useMemo } from "react";
import { Button } from "primereact/button";
import GetUserInfoService from "../../service/GetUserInfoService";
import { usePayment } from "../../pages/ShoppingCart/components/Checkout/context/PaymentContext";
import { useContext } from "react";
import { CartContext } from "../../contexts/CartContext/CartContext";

const SubmitPayment = ({ isPaying, setIsPaying, toast }) => {
  const { cardFieldsForm } = usePayPalCardFields();

  async function submitHandler() {
    if (!cardFieldsForm) {
      return;
    }

    const formState = await cardFieldsForm.getState();

    if (!formState.isFormValid) {
      if (toast && toast.current) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("invalidCardDetails"),
          life: 6000,
        });
      }
      return;
    }

    setIsPaying(true);

    try {
      await cardFieldsForm.submit();
    } catch (error) {
      setIsPaying(false);

      if (toast && toast.current) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: "Erro ao processar pagamento. Tente novamente.",
          life: 6000,
        });
      }
    }
  }

  return (
    <Button
      className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
      style={{ backgroundColor: "#28AB69" }}
      label={localeText("payNow")}
      loading={isPaying}
      onClick={submitHandler}
    ></Button>
  );
};

const PayPalCardFieldsOnly = (props) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const {
    setDisplayPaymentModal,
    setIdTransaction,
    priceOriginal,
    toast,
    userCurrency,
    price: propsPrice,
  } = props;
  const {
    setPage,
    address,
    city,
    country,
    district,
    number,
    postalCode,
    state,
    amountWallet,
    amountToPayWithExtracredit,
    amountBankTransfer,
    order: contextOrder,
    calculateTotalPrice,
  } = usePayment();
  const latestAmountWallet = useRef(amountWallet || 0);
  const latestAmountToPayWithExtracredit = useRef(amountToPayWithExtracredit || 0);
  const latestAmountBankTransfer = useRef(amountBankTransfer || 0);

  if (amountWallet !== latestAmountWallet.current) {
    latestAmountWallet.current = amountWallet || 0;
  }
  if (amountToPayWithExtracredit !== latestAmountToPayWithExtracredit.current) {
    latestAmountToPayWithExtracredit.current = amountToPayWithExtracredit || 0;
  }
  if (amountBankTransfer !== latestAmountBankTransfer.current) {
    latestAmountBankTransfer.current = amountBankTransfer || 0;
  }

  const { clearCart } = useContext(CartContext);

  const order = contextOrder || JSON.parse(localStorage.getItem(orderKey) || 'null');

  const price = propsPrice || priceOriginal || 0;

  const Navigate = useHistory();

  const orderService = useMemo(() => new OrderService(), []);
  const advancedPayPalService = useMemo(() => new AdvancedPayPalService(), []);
  const integrationService = useMemo(() => new IntegrationService(), []);
  const getUserInfoService = useMemo(() => new GetUserInfoService(), []);

  const orderId = useRef(null);
  const [isPaying, setIsPaying] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const initialPrice = useRef(price);
  const latestPrice = useRef(price);
  latestPrice.current = price;

  if (price > 0 && price !== initialPrice.current) {
    initialPrice.current = price;
  }

  const finishOrder = useCallback(
    async (transactionID) => {
      let amountBankTransfer = parseFloat(
        (props.amountBankTransfer ? props.amountBankTransfer : 0).toFixed(2)
      );

      async function sendPurchase() {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "Purchase",
        });
        const user = await getUserInfoService.getUserInfo(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        let ip = await integrationService.getUserIp();
        let date = new Date();
        let payload = {
          eventData: {
            currency: userCurrency,
            value: price,
          },
          eventName: "Purchase",
          eventTime: Math.floor(date.getTime() / 1000),
          userData: {
            email: user.result.user?.email ? user.result.user.email : "",
            ipAddress: ip.data.ip,
            phone: user.result.user?.phoneNumber ? user.result.user.phoneNumber : "",
            userAgent: window.navigator.userAgent,
          },
        };
        let res = await integrationService.sendEvent(payload);
        return res;
      }

      try {
        props.setLoading(true);

        let res;

        if (isFringeBenefitsPage) {
          res = await orderService.postFinishFringeBenefitOrder(
            amountWallet ?? 0,
            parseFloat(
              (props?.amountToPayWithExtracredit ? props?.amountToPayWithExtracredit : 0).toFixed(2)
            ),
            amountBankTransfer,
            props?.bankTransferReceipt,
            order?.id,
            transactionID,
            price
          );
        } else {
          const totalOrder = calculateTotalPrice();
          const amountWalletValue = latestAmountWallet.current ?? 0;

          const amountExtracredit = parseFloat(
            (latestAmountToPayWithExtracredit.current || 0).toFixed(2)
          );
          const amountBankTransferValue = parseFloat(
            (latestAmountBankTransfer.current || 0).toFixed(2)
          );

          const amountCash = parseFloat(
            (
              totalOrder -
              amountWalletValue -
              amountExtracredit -
              amountBankTransferValue
            ).toFixed(2)
          );

          console.log("FINISH ORDER - Cartão");
          console.log("Total Order:", totalOrder);
          console.log("Amount Wallet:", amountWalletValue);
          console.log("Amount Extracredit:", amountExtracredit);
          console.log("Amount Bank Transfer:", amountBankTransferValue);
          console.log("Amountcash:", amountCash);
          console.log("Soma:", amountWalletValue + amountExtracredit + amountBankTransferValue + amountCash);


          res = await orderService.postFinishOrder(
            localStorage.getItem("__extraconomy_token"),
            localStorage.getItem("__extraconomy_username"),
            address,
            amountCash,
            amountWalletValue,
            amountExtracredit,
            amountBankTransferValue,
            props?.bankTransferReceipt,
            city,
            country,
            district,
            order?.id,
            number,
            postalCode,
            state,
            transactionID
          );
        }

        if (res.messageCode === 200000) {
          localStorage.removeItem(orderKey);
          clearCart();
          setDisplayPaymentModal(false);
          setIsPaying(false);
          setPage(4);

          try {
            const timeout = new Promise((_, reject) =>
              setTimeout(() => reject(new Error("sendPurchase timeout")), 5000)
            );
            await Promise.race([sendPurchase(), timeout]);
          } catch (sendPurchaseError) {
          }
        } else {
          const errorMessage = localeText("data")?.find((msg) => msg.code === res.messageCode);
          toast?.current?.show?.({
            severity: "error",
            summary: localeText("error"),
            detail: errorMessage?.message || `${localeText("errorOfSystem")} (Código: ${res.messageCode})`,
            life: 6000,
          });
          setPage(5);
          props.setLoading(false);
          setIsPaying(false);
          return false;
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          removelocalStorageToken();
          removelocalStorageUsername();
          Navigate.push("/login");
        }
        props.setLoading(false);
        setIsPaying(false);
        return false;
      }
    },
    [
      props,
      isFringeBenefitsPage,
      orderKey,
      orderService,
      amountWallet,
      order?.id,
      price,
      toast,
      setDisplayPaymentModal,
      Navigate,
      setPage,
      address,
      city,
      country,
      district,
      number,
      postalCode,
      state,
      clearCart,
      getUserInfoService,
      integrationService,
      userCurrency,
      latestAmountWallet,
      latestAmountToPayWithExtracredit,
      latestAmountBankTransfer,
      calculateTotalPrice,
    ]
  );

  const createOrder = useCallback(async () => {
    try {
      const currentPrice = latestPrice.current;
      if (!currentPrice || currentPrice <= 0) {
        return false;
      }

      const payload = {
        amount: currentPrice,
        currency: "EUR",
        returnUrl: "https://example.com/success",
        cancelUrl: "https://example.com/cancel",
      };

      const res = await advancedPayPalService.createOrder(payload);

      if (!res || !res.id) {
        return false;
      }

      orderId.current = res.id;
      return res.id;
    } catch (e) {
      return false;
    }
  }, [advancedPayPalService]);

  const onApprove = useCallback(
    async (data, actions) => {
      try {
        setIsPaying(true);
        setIsProcessingPayment(true);
        props.setLoading(true);

        if (isFringeBenefitsPage) {
          const captureRes = await advancedPayPalService.captureOrder(orderId.current);
          setIdTransaction(captureRes.id);
          localStorage.removeItem(orderKey);
          clearCart();
          await finishOrder(captureRes.id);
          return data;
        }

        const totalOrder = calculateTotalPrice();
        const amountWalletValue = latestAmountWallet.current ?? 0;
        const amountExtracredit = parseFloat(
          (latestAmountToPayWithExtracredit.current || 0).toFixed(2)
        );
        const amountBankTransferValue = parseFloat(
          (latestAmountBankTransfer.current || 0).toFixed(2)
        );

        const amountCash = parseFloat(
          (
            totalOrder -
            amountWalletValue -
            amountExtracredit -
            amountBankTransferValue
          ).toFixed(2)
        );

        console.log("VALIDATEBEFOREFINISH - Card Fields");
        console.log("Total Order:", totalOrder);
        console.log("Amount Wallet:", amountWalletValue);
        console.log("Amount Extracredit:", amountExtracredit);
        console.log("Amount Bank Transfer:", amountBankTransferValue);
        console.log("amountcash:", amountCash);
        console.log("Soma:", amountWalletValue + amountExtracredit + amountBankTransferValue + amountCash);

        const validationRes = await orderService.validateBeforeFinish(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          address,
          amountCash,
          amountWalletValue,
          amountExtracredit,
          amountBankTransferValue,
          props?.bankTransferReceipt,
          city,
          country,
          district,
          order?.id,
          number,
          postalCode,
          state
        );

        if (!String(validationRes.messageCode).startsWith("2")) {
          const errorMessage = localeText("data")?.find((msg) => msg.code === validationRes.messageCode);
          toast?.current?.show?.({
            severity: "error",
            summary: localeText("paymentSubmissionFailed"),
            detail: errorMessage?.message || localeText("pleaseTryAgain"),
            life: 6000,
          });
          props.setLoading(false);
          setIsPaying(false);
          setIsProcessingPayment(false);
          setPage(5);
          return false;
        }

        console.log("Validação OK");
        const captureRes = await advancedPayPalService.captureOrder(orderId.current);

        setIdTransaction(captureRes.id);

        if (props.onCreditCardApproved) {
          const remainingForCreditCard = parseFloat(
            (totalOrder - amountWalletValue - amountExtracredit - amountBankTransferValue).toFixed(2)
          );
          props.onCreditCardApproved(remainingForCreditCard);
        }

        console.log("Pagamento capturado", captureRes.id);
        localStorage.removeItem(orderKey);
        clearCart();
        await finishOrder(captureRes.id);

        return data;
      } catch (err) {
        console.error("Erro no onApprove:", err);
        toast?.current?.show?.({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorTransaction"),
          life: 6000,
        });
        setIsPaying(false);
        setIsProcessingPayment(false);
        props.setLoading(false);
        setPage(5);
        return false;
      }
    },
    [
      advancedPayPalService,
      orderId,
      setIdTransaction,
      props,
      latestAmountToPayWithExtracredit,
      latestAmountBankTransfer,
      latestAmountWallet,
      orderService,
      address,
      city,
      country,
      district,
      number,
      postalCode,
      state,
      order?.id,
      toast,
      setPage,
      calculateTotalPrice,
      isFringeBenefitsPage,
      orderKey,
      clearCart,
      finishOrder,
    ]
  );

  return (
    <>
      {(price > 0 || initialPrice.current > 0 || isPaying || isProcessingPayment) && (
        <>
          <div className="mt-3">
            <h4 className="text-left text-lg font-semibold">{localeText("creditCardInfo")}</h4>
          </div>
          <PayPalCardFieldsProvider
            options={{ currency: "EUR" }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={(err) => {
              toast?.current?.show?.({
                severity: "error",
                summary: localeText("error"),
                detail: localeText("unexpectedErrorTransaction"),
                life: 6000,
              });
            }}
          >
            <PayPalNameField placeholder={localeText("name")} />
            <PayPalNumberField placeholder={localeText("cardNumber")} />
            <PayPalExpiryField placeholder={localeText("expirationDate")} />
            <PayPalCVVField placeholder={localeText("securityCode")} />
            <SubmitPayment toast={toast} isPaying={isPaying} setIsPaying={setIsPaying} />
          </PayPalCardFieldsProvider>
        </>
      )}
    </>
  );
};

export default PayPalCardFieldsOnly;
